<template>
    <div>
        <b-card no-body v-show="mostrarJobs">
            <b-card-header>
                <h5>JOBs</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblJobs"
                    :itens="jobs"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="reiniciarJobs()"
                                v-if="mostrarBtnReiniciarJobs"
                                >Reiniciar Jobs</b-button
                            >
                        </b-button-group>
                    </template>
                    <!-- <template slot="cpfCnpj" slot-scope="data">
                        <span>{{ data.cpfCnpj | toCpfCnpj }}</span>
                    </template> -->
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="$temAcessoView('ADMIN-JOBS-00')"
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharJob(data.jobId)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view :job="job" v-if="job.jobId"></router-view>
    </div>
</template>

<script>
import JobsServicos from './JobsServicos'
// import BtnImportarDirf from './BtnImportarDirf'

export default {
    //   props: {
    //     expressoPlanilhas: {
    //       type: Array,
    //       default: () => ([])
    //     }
    //   },
    components: {
        // BtnImportarDirf
    },

    data() {
        return {
            jobs: [],
            job: {},
            campos: [
                {
                    key: 'jobId',
                    label: 'Job',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'cron',
                    label: 'CRON',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        obterJobs() {
            this.$store.dispatch('addRequest')
            JobsServicos.obterTodos().then(response => {
                if (response) {
                    if (response.success) {
                        this.jobs = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os Jobs',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharJob(jobId) {
            this.job = this.jobs.filter(p => {
                return p.jobId == jobId
            })[0]
            this.$router.push({
                name: 'Jobs_Detalhar',
                params: {
                    jobId
                }
            })
        },

        reiniciarJobs() {
            this.$store.dispatch('addRequest')
            JobsServicos.reiniciarJobs().then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Jobs reiniciados com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(
                            'Erro ao reiniciar jobs',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterJobs()
    },

    computed: {
        mostrarJobs() {
            return this.$route.name == 'Jobs'
        },

        mostrarBtnReiniciarJobs() {
            return this.$temAcessoView('ADMIN-JOBS-01')
        }
    },

    watch: {}
}
</script>
